export default __webpack_public_path__ + "static/media/avatar.9999920b.webp";